import script from "./MerchantSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantSelector.vue?vue&type=script&setup=true&lang=js"

import "./MerchantSelector.vue?vue&type=style&index=0&id=b6d884bc&lang=css"

const __exports__ = script;

export default __exports__